/* tslint:disable */
/* eslint-disable */
import { ShiftType } from '../enums/shift-type';
export { ShiftType }
